import React, {useEffect} from 'react';
import 'antd/dist/antd.css';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  BrowserRouter,
} from 'react-router-dom';
import './App.css';

import {Layout} from 'antd';
import {store} from './redux/store';

import {
  getMe,
  setLastSeenOnline,
} from './redux/actions/user';
import {Provider} from 'react-redux';
import {Routers} from './components/Routers';

function App() {
  useEffect(() => {
    //@ts-ignore
    store.dispatch(getMe());

    //@ts-ignore
    store.dispatch(setLastSeenOnline());
  }, []);

  return (
    <>
      <Router>
        <Provider store={store}>
          <Layout>
            <BrowserRouter>
              <Switch>
                <Route
                  render={() => {
                    return <Routers />;
                  }}
                />
              </Switch>
            </BrowserRouter>
          </Layout>
        </Provider>
      </Router>
    </>
  );
}

export default App;
//export default App;
